export default {
    computed:{
        linkItem(){
            if(this.block.hasLink){
                return this.block.lien
            }
            return null;
        }
    }
}